import VCharts from 'v-charts'
import lyaiView from './echart/lyai-view.vue'
import lyaiViewComponent from './echart/lyai-view-component.vue'

export default {
	install(Vue) {
		Vue.use(VCharts)
		Vue.component(lyaiView.name, lyaiView)
		Vue.component(lyaiViewComponent.name, lyaiViewComponent)
	}
}
